<template lang="html">
    <span>        
        <common-tooltip-inner :visible="popupVisible" :title="basedataGetName('SysTip',tipCode)">
            <i class="iconfont icon-tishi1" :class="isView?'view':''" @click.prevent="handleShowTooltip"></i>
        </common-tooltip-inner>
    </span>
</template>

<script>
import { Popup  } from 'mint-ui';
import { mapGetters } from 'vuex';
import CommonTooltipInner from './CommonTooltipInner';
  export default {
    components: {
        CommonTooltipInner,
        Popup,
    },
    props: {
        'tipCode': {
            required: true
        },
        'isView': {
            type:Boolean,
            required: false
        },
    },
    data() {
        return {
            popupVisible: false,           
        }
    },    
    methods: {
        handleShowTooltip() {
            this.popupVisible = true;
            setTimeout(() => {
                this.popupVisible = false;
            }, 3000)
        },
    },
    computed: {        
        ...mapGetters(['basedataGetName']),
    },
  };
</script>
<style lang="less" scoped>
    .iconfont {
        font-size: 14px;
        line-height: 24px;
        margin-left: 5px;
        color: #333;
    }
    .iconfont.view {
        line-height: 35px;
    }

    .popup-tooltip {
        width: 200px;
        border-radius: 8px;
        padding: 10px;
        transform: translate(-50%, 0);
    }
</style>


// WEBPACK FOOTER //
// CommonTooltip.vue?3d1b8dad